import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PaginatorModule } from 'primeng/paginator';
import { CarouselModule } from 'primeng/carousel';
import { SelectModule } from 'primeng/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ArticleListComponent } from './article-list/article-list.component';
import { HomeComponent } from './home/home.component';
import { ArticleComponent } from './article/article.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { SectionComponent } from './section/section.component';
import { CategoryComponent } from './category/category.component';
import { CategoryListComponent } from './category-list/category-list.component';
import { ArticleSummaryComponent } from './article-summary/article-summary.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { MoreArticlesComponent } from './more-articles/more-articles.component';
import { NoSanitizePipe } from './no-sanitize.pipe';
import { TourComponent } from './tour/tour.component';
import { TourListComponent } from './tour-list/tour-list.component';
import { TourSequenceComponent } from './tour-sequence/tour-sequence.component';
import { LegacyArticleRedirectComponent } from './legacy-article-redirect/legacy-article-redirect.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { CarouselComponent } from './carousel/carousel.component';
import { TopArticlesComponent } from './top-articles/top-articles.component';

@NgModule({
  declarations: [
    AppComponent,
    ArticleListComponent,
    HomeComponent,
    ArticleComponent,
    HeaderComponent,
    FooterComponent,
    PageHeaderComponent,
    SectionComponent,
    CategoryComponent,
    CategoryListComponent,
    ArticleSummaryComponent,
    BreadcrumbComponent,
    MoreArticlesComponent,
    NoSanitizePipe,
    TourComponent,
    TourListComponent,
    TourSequenceComponent,
    LegacyArticleRedirectComponent,
    FeedbackComponent,
    CarouselComponent,
    TopArticlesComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BreadcrumbModule,
    FormsModule,
    PaginatorModule,
    CarouselModule,
    SelectModule,
    BrowserAnimationsModule,
    FormsModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
